import routerOptions0 from "/src/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}